"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectChatUiContextSchema = exports.statusUpdateScopeSchema = void 0;
const zod_1 = require("zod");
exports.statusUpdateScopeSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.object({ type: zod_1.z.literal("days"), days: zod_1.z.number() }),
    zod_1.z.object({ type: zod_1.z.literal("since_last_update") }),
    zod_1.z.object({ type: zod_1.z.literal("since_project_start") }),
    zod_1.z.object({ type: zod_1.z.literal("custom"), startDate: zod_1.z.string(), endDate: zod_1.z.string() }),
]);
const statusUpdateUiContextSchema = zod_1.z.object({
    type: zod_1.z.literal("status-update"),
    scope: exports.statusUpdateScopeSchema,
});
exports.projectChatUiContextSchema = zod_1.z
    .discriminatedUnion("type", [
    zod_1.z.object({ type: zod_1.z.literal("workstream"), id: zod_1.z.string() }),
    zod_1.z.object({
        type: zod_1.z.literal("deliverable"),
        workstreamId: zod_1.z.string(),
        id: zod_1.z.string(),
    }),
    zod_1.z.object({ type: zod_1.z.literal("meetings") }),
    zod_1.z.object({ type: zod_1.z.literal("project-history") }),
    statusUpdateUiContextSchema,
])
    .nullable();
